import { render, staticRenderFns } from "./NoteViz.vue?vue&type=template&id=de665dd2&scoped=true&"
import script from "./NoteViz.vue?vue&type=script&lang=js&"
export * from "./NoteViz.vue?vue&type=script&lang=js&"
import style0 from "./NoteViz.vue?vue&type=style&index=0&id=de665dd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de665dd2",
  null
  
)

export default component.exports